<script setup lang="ts">
import VeeTextField from '@/components/forms/TextField/VeeTextField.vue';
import { mdiCalendar } from '@mdi/js';
import { maskitoDateOptionsGenerator } from '@maskito/kit';

const generated = maskitoDateOptionsGenerator({
  mode: 'yyyy/mm/dd',
  separator: '-',
});

// dropped Maskito's min/max postprocessor because it overflows invalid days via
// native Date (2025-02-30 -> Mar). Leave the typed value for backend validation.
const maskOptions = {
  ...generated,
  postprocessors: generated.postprocessors?.slice(0, -1) ?? [],
};

defineProps<{ name: string }>();
</script>

<template>
  <VeeTextField
    v-maskito="maskOptions"
    :name="name"
    :prependInnerIcon="mdiCalendar"
    :placeholder="$t('YearMonthDay')"
  />
</template>
